import { FieldInfo } from './schema-parser';

// 完整的类型映射
export function mapDrizzleTypeToTS(field: FieldInfo): string {
  const typeMap: Record<string, string> = {
    // String types
    char: 'string',
    varchar: 'string',
    text: 'string',

    // Numeric types
    smallint: 'number',
    integer: 'number',
    int: 'number',
    bigint: 'string', // bigint 在 JS 中通常作为 string 处理
    serial: 'number',
    smallserial: 'number',
    bigserial: 'string',

    // Decimal types
    decimal: 'string', // 精确数值通常用 string
    numeric: 'string',
    real: 'number',
    doublePrecision: 'number',

    // Boolean
    boolean: 'boolean',

    // Date/Time types
    timestamp: 'Date',
    timestamptz: 'Date',
    date: 'Date',
    time: 'string',
    timetz: 'string',
    interval: 'string',

    // UUID
    uuid: 'string',

    // JSON types
    json: 'any',
    jsonb: 'any',

    // Binary
    bytea: 'Buffer',

    // Network types
    inet: 'string',
    cidr: 'string',
    macaddr: 'string',
    macaddr8: 'string',

    // Geometric types
    point: '{ x: number; y: number }',
    line: 'string',
    lseg: 'string',
    box: 'string',
    path: 'string',
    polygon: 'string',
    circle: 'string',

    // Array types (handled by isArray flag)
    array: 'any[]',

    // Custom types
    customType: 'any',
    customTimestamptz: 'Date',
    userProfile: 'string',
    fileAttachment: 'FileAttachment',

    // Enum (handled separately)
    pgEnum: 'string',
  };

  let baseType = typeMap[field.type] || 'any';

  // 处理数组类型
  if (field.isArray) {
    baseType = baseType.endsWith('[]') ? baseType : `${baseType}[]`;
  }

  // 处理枚举
  if (field.enumValues && field.enumValues.length > 0) {
    baseType = field.enumValues.map((v) => `'${v}'`).join(' | ');
  }

  return baseType;
}

// 辅助函数
export function toPascalCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(/[-_\s]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
}

export function toKebabCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .replace(/[_\s]/g, '-');
}

export function toSnakeCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toLowerCase()
    .replace(/[-\s]/g, '_');
}
